<div class="modal fade show px-1" style="display: block; background: #00000080;">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Authentication expired!</h5>
        <button type="button" class="close" (click)="configService.logoutUser()">
          <span>×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="">
          Your access authentication has expired, Please login again
        </div>
      </div>
      <!-- <div class="modal-footer">
        <div class="row w-100 px-1">
          <div class="col-12 px-1">
            <button type="submit" class="save-btn w-100">
              Click to login
            </button>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div> 